import LostPetsService from '@/services/lostPets'
import EnvironmentUtils from '@/utils/environmentUtils'

async function initFrame (vuexStore)
{
    const { cityId, cityFeatures } = EnvironmentUtils
    const token = vuexStore.state.user.token
    const privileges = vuexStore.state.user.privileges

    if (!cityFeatures.hasLostPets) return

    if (privileges.canManageLostPets)
    {
        LostPetsService.getLostPetsTagsDefinition(cityId, token).then(async tags =>
        {
            await vuexStore.commit('lostPets/setTags', tags)
        })
    }
    
    LostPetsService.fetchPublishedLostPets(cityId).then(pets =>
    {
        vuexStore.commit('lostPets/updatePetsList', pets)
    })
}

export default { initFrame }


// WEBPACK FOOTER //
// ./src/frames/lostPetsFrame.js